<template>
    <div class="d-flex flex-wrap p-0 m-0">

        <form-field :label="getFieldLabel('actNumber')"
                    class="col-xs-12 col-sm-4 col-md-3 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.actNumber"
                    :editable="isEditable('actNumber')"
                    :feedback="liveFeedback('actNumber')">
            <template #field>
                    <b-input
                        id="actNumber"
                        class="w-100"
                        placeholder="№"
                         v-model="$v.form.actNumber.$model"
                        :state="validateState('actNumber')">
                    </b-input>
            </template>
        </form-field>

        <date-time-picker class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mr-0 mr-sm-3 mt-3 p-0"
                          ref="actDate"
                          :title="getFieldLabel('actDate')"
                          name="actDate"
                          :editable="isEditable('actDate')"
                          :show-timepicker="false"
                          :date-required="false"
                          :key="getActDate()"
                          :initial-date-string="getActDate()"
                          :state="validateState('actDate')"
                          @date-changed="onModelDateChanged" />

        <form-field :label="getFieldLabel('ownerType')"
                    class="required col-xs-12 col-sm-6 col-md-4 col-lg-3 p-0 mr-3 mt-3"
                    :value="object.ownerTypeText"
                    :editable="isEditable('ownerType')"
                    :feedback="liveFeedback('ownerType')">

                <template #field>
                    <radio-list  id="ownerType"
                                name="ownerType"
                                v-model="form.ownerType"
                                :url="ownerTypeUrl"
                                @radio-changed="onModelObjectRadioChanged" />
                </template>
        </form-field>

        <form-field :label="getFieldLabel('ownerName')"
                    class="col-xs-12 col-sm-8 col-md-5 col-lg-4 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.ownerName"
                    :editable="isEditable('ownerName')"
                    :feedback="liveFeedback('ownerName')">
            <template #field>
                    <b-input
                        id="ownerName"
                        class="w-100"
                         v-model="$v.form.ownerName.$model"
                        :state="validateState('ownerName')">
                    </b-input>
            </template>
        </form-field>

        <form-field
                :label="getFieldLabel('address')"
                class="col-xs-12 col-md-6 p-0 mr-0 mr-sm-3 mt-3"
                :editable="isEditable('address')"
                :feedback="liveFeedback('address')"
                :value="form.addressObject && form.addressObject['human_readable_address'] ? form.addressObject['human_readable_address'] : 'Не указан'">
            <template #field>
                <single-select name="address"
                               class="flex-grow-1"
                               v-model="form['addressObject']"
                               :url="addressUrl"
                               :label="getFieldLabel('address')"
                               label-key="human_readable_address"
                               :state="getValidationClass('address')"
                               :has-pagination="false"
                               v-on:select-changed="onModelObjectSingleSelectChanged"
                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
            </template>
        </form-field>

        <form-field :label="getFieldLabel('comment')"
                    class="col-xs-12 col-sm-12 col-md-8 col-lg-6 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.comment"
                    :editable="isEditable('comment')"
                    :feedback="liveFeedback('comment')">
            <template #field>
                    <b-textarea
                        id="comment"
                        class="w-100"
                         v-model="$v.form.comment.$model"
                        rows="4"
                        :state="validateState('comment')">
                    </b-textarea>
            </template>
        </form-field>

    </div>
</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
    import {OwnerEventAttributes} from "./owner";
    import DateTimePicker from "../../../../components/Forms/DateTimePicker";
    import {todayStr} from "@/utils/dateFormat";
    import api from '../../../../api';
    import RadioList from "@/components/Select/RadioList";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import SingleSelect from "@/components/Select/SingleSelect.vue";

    export default {
        name: "OwnerAttributes",
        components: {SingleSelect, RadioList, FormField, DateTimePicker },
        mixins: [ObjectComponentMixin, AttributeMixin],
        computed: {
            ownerTypeUrl() { return api.animals.ownerTypes.list(api.animals.default.list()) },
            addressUrl() {return api.addresses.search.list()}
        },
        methods: {
            getActDate() {
                return this.object.actDate;
            }
        },
        beforeMount() {
            this.objectClass = OwnerEventAttributes;
            this.initialize();
            this.initObjectParams['actDate'] = todayStr();
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },
    }
</script>

<style scoped>

</style>